<template>
  <div class="f-relative sm:f-inline-block">
    <svg
      v-on:mouseover="showShippingInfo = true"
      v-on:mouseleave="showShippingInfo = false"
      class="f-w-5"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
    <div
      v-show="showShippingInfo"
      class="f-absolute f-bg-white f-border f-p-1 f-rounded f-w-max f-top-0 f-ml-10 f--mt-1 f-z-10"
    >
      <div
        class="f-w-3 f-h-3 f-border-b f-rounded-b f-border-l f-transform f-rotate-45 f-absolute f-bg-white"
        style="margin: 5px 0 0 -11px"
      ></div>
      <div
        class="f-relative f-text-sm f-text-gray-700 f-px-1"
        style="max-width: 200px"
      >
        {{ description }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  name: "ShippingPopover",

  props: {
    description: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      showShippingInfo: false,
    };
  },
});
</script>
